// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.

/**
 * Short, phonetically-distinct words for the Short Authentication String (SAS)
 * and for human-readable passphrases. Chosen to be easy to read aloud over a
 * call and hard to mishear. The list is deliberately kept free of homophones.
 *
 * Security note: the SAS maps four key-derived bytes onto four words via
 * `WORDS[byte % WORDS.length]`. With this list length that is roughly 4·log2(N)
 * bits of out-of-band verification — ample for a human to catch a relay that
 * tries to bridge two different rooms.
 */
export const WORDS: readonly string[] = [
  'acorn', 'amber', 'anchor', 'apple', 'apricot', 'arch', 'arena', 'aspen',
  'atlas', 'aurora', 'autumn', 'bacon', 'badge', 'bamboo', 'banjo', 'basil',
  'beacon', 'beetle', 'birch', 'bishop', 'bison', 'blossom', 'bongo', 'boron',
  'boulder', 'brass', 'bronze', 'bucket', 'buffalo', 'cactus', 'camel', 'canyon',
  'cargo', 'cedar', 'cello', 'cherry', 'chess', 'chestnut', 'clover', 'cobalt',
  'cobra', 'comet', 'copper', 'coral', 'cosmic', 'cotton', 'cricket', 'crimson',
  'crystal', 'cyclone', 'daffodil', 'dahlia', 'daisy', 'delta', 'denim', 'diamond',
  'domino', 'dragon', 'dune', 'eagle', 'ember', 'emerald', 'engine', 'falcon',
  'feather', 'fennel', 'ferry', 'fiber', 'fiddle', 'flamingo', 'flint', 'forest',
  'fossil', 'fountain', 'foxglove', 'galaxy', 'garlic', 'ginger', 'glacier', 'granite',
  'harbor', 'hazel', 'helium', 'heron', 'hickory', 'hollow', 'hornet', 'ignite',
  'indigo', 'ivory', 'jaguar', 'jasmine', 'jersey', 'juniper', 'kayak', 'kernel',
  'kettle', 'koala', 'lagoon', 'lantern', 'lemon', 'lentil', 'lilac', 'linen',
  'lobster', 'locust', 'lotus', 'lunar', 'magnet', 'mango', 'maple', 'marble',
  'meadow', 'mellow', 'meteor', 'mint', 'mocha', 'mosaic', 'moss', 'nebula',
  'nectar', 'needle', 'neon', 'nickel', 'nomad', 'nutmeg', 'oasis', 'ocean',
  'olive', 'onyx', 'opal', 'orbit', 'orchid', 'osprey', 'otter', 'oxide',
  'paddle', 'pallet', 'pansy', 'pastel', 'peach', 'pebble', 'pepper', 'pewter',
  'phantom', 'pigeon', 'pilot', 'pine', 'pixel', 'planet', 'plaza', 'plum',
  'pollen', 'poppy', 'portal', 'prairie', 'prism', 'pueblo', 'pumpkin', 'quartz',
  'quiver', 'radish', 'rapids', 'raven', 'reef', 'rhubarb', 'ribbon', 'ripple',
  'river', 'robin', 'rocket', 'rooster', 'rosemary', 'ruby', 'rustic', 'saffron',
  'sage', 'salmon', 'sandbar', 'sapphire', 'satin', 'scarlet', 'sequoia', 'shadow',
  'shamrock', 'shelter', 'silver', 'sienna', 'signal', 'silk', 'sonata', 'spark',
  'sparrow', 'spruce', 'stallion', 'starling', 'stellar', 'summit', 'sunbeam', 'sunset',
  'sycamore', 'tango', 'tapioca', 'teal', 'thistle', 'thunder', 'timber', 'topaz',
  'tortoise', 'tulip', 'tundra', 'turquoise', 'umbra', 'valley', 'velvet', 'venus',
  'violet', 'walnut', 'walrus', 'willow', 'window', 'winter', 'wombat', 'yarrow',
  'zephyr', 'zinnia',
];
